import {FETCH_PERSONAL_REQUEST, FETCH_PERSONAL_SUCCES, FETCH_PERSONAL_ERROR} from '../constants/Personal'
import { jsonGet, errorHandler } from '../utils/Request';

const loadPersonal = () => (dispatch) => {
  const apiUrl = '/personal/list/';
  dispatch({
    type: FETCH_PERSONAL_REQUEST,
  });
  return jsonGet(apiUrl)
    .then(json => {
      dispatch({
        type: FETCH_PERSONAL_SUCCES,
        payload: json,
      });
    })
    .catch((e) => {
      dispatch({
        type: FETCH_PERSONAL_ERROR
      });
      errorHandler(e);
    });
};

export { loadPersonal };



// WEBPACK FOOTER //
// ./src/actions/PersonalActions.js